import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @typescript-eslint/no-explicit-any */
import TextField from "@material-ui/core/esm/TextField";
import Autocomplete from "@material-ui/lab/esm/Autocomplete";
import { nanoid } from 'nanoid';
import React from 'react';
import { BoldSubtitle } from 'components/Text';
export default function AutocompleteSync({
  options,
  label,
  optionLabel,
  defaultValue,
  onChange,
  getOptionSelected,
  name,
  disabled
}) {
  const handleChange = (_event, inputValue) => {
    onChange(inputValue);
  };
  const id = nanoid();
  if (!options) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(BoldSubtitle, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label)), /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    style: {
      width: '100%',
      maxWidth: 300
    },
    options: options,
    autoHighlight: true,
    onChange: handleChange,
    defaultValue: defaultValue,
    getOptionLabel: option => {
      if (typeof optionLabel === 'string') return option[optionLabel];
      return option[optionLabel[0]] || option[optionLabel[1]];
    },
    getOptionSelected: getOptionSelected ? (option, v) => option[optionLabel] === v[optionLabel] : undefined,
    renderOption: option => /*#__PURE__*/React.createElement(React.Fragment, null, option && option[optionLabel]),
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      variant: "outlined",
      name: name,
      inputProps: {
        ...params.inputProps,
        autoComplete: 'new-password' // disable autocomplete and autofill
      }
    })),
    disabled: disabled
  }));
}
AutocompleteSync.defaultProps = {
  getOptionSelected: false,
  disabled: false
};